// Imports
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControlLabel from "@material-ui/core/FormControlLabel";
// UI Imports
import Grid from "@material-ui/core/Grid/Grid";
import IconButton from "@material-ui/core/IconButton";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconArrowBack from "@material-ui/icons/ArrowBack";
import CheckIcon from "@mui/icons-material/Check";
import IconClose from "@material-ui/icons/Close";
import dayjs from "dayjs";
import customFormat from "dayjs/plugin/customParseFormat";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
// App Imports
import params from "../../../setup/config/params";
import { list as listCategories } from "../../category/api/actions/query";
import { detail as fetchSettingDetail } from "../../setting/api/actions/query";
import { messageShow, multipleUpload, upload } from "../../common/api/actions";
import ImageComp from "../../common/Image";
import BrandedLoading from "../../common/BrandedLoading";
import SectionPaper from "../../common/SectionPaper";
import { listVendorsAll, detail as fetchUserDetail } from "../../user/api/actions/query";
import { createOrUpdate, productPurchase } from "../api/actions/mutation";
import { details, getUnitType } from "../api/actions/query";
import routes, { getImageSource } from "../api/routes";
import styles from "./styles";
import { checkPermission } from "../../common/Sidebar/checkPermission";
import BusinessForm from "./BusinessForm";
import ValidationTooltip from "../../common/ValidationTooltip";

const nullToEmptyString = (value) => (value === null || value === undefined ? "" : value);

// Component
class CreateOrUpdate extends Component {
  constructor(props) {
    super(props);
    dayjs.extend(customFormat);
    this.settings = {
      onlinePricingPercentage: "" || 0,
    }

    this.product = {
      _id: "",
      vendorId: "",
      categoryId: "",
      name: "",
      slug: "",
      brand: "",
      description: "",
      detailedDescription: "",
      price: "" || 0,
      priceDiscount: "" || 0,
      priceDiscounted: "" || 0,
      unit: "",
      unitTypes: [],
      unitTypeId: "",
      openingStock: "",
      barcode: "",
      purchase: "",
      image: "default.jpg",
      gallery: [],
      // canSubscribe: true,
      storePrice: 0,
      isVeg: false,
      isNonVeg: false,
      isPublished: true,
      isFeatured: false,
      onlinepercentage: [],
      isLiveCounterItem: false,
      availability: {
        homeDelivery: false,
        storePickup: false
      },
      available_days: [],
      available_time: {
        startTime: "",
        endTime: ""
      },
      seo: {
        title: "",
        description: "",
        keywords: "",
        ogImage: ""
      },
      features: [],
      featureDetails: {},
      buttonText: "",
      buttonLink: ""
    };

    this.state = {
      isLoading: false,
      isLoadingSubmit: false,
      isUploadingFile: false,
      purchaseCount: 0,
      vendors: [],
      product: this.product,
      purchaseShow: false,
      previewImage: null,
      isPickupAtStore: null,
      isHomeDelivery: null,
      seoEnabled: false,
      permissions: {
        canView: false,
        canCreate: false,
        canEdit: false,
        canDelete: false
      },
      vendorIndustryType: '',
      errors: {},
      activeErrorField: null
    };
    this.onChangeVegOrNonveg = this.onChangeVegOrNonveg.bind(this);

  }
  componentDidMount() {
    const {
      auth: { user },
      match: {
        params: { productId },
      },
      location
    } = this.props;

    // Get categories
    this.getCategories();
    this.fetchUnitTypes();
    this.verifyPermissions();
    const isPickupAtStore = location.state?.isPickupAtStore;
    const isHomeDelivery = location.state?.isHomeDelivery;

    if (isPickupAtStore !== undefined && isHomeDelivery !== undefined) {
      this.setState({ isPickupAtStore, isHomeDelivery });
    }

    if (productId) {
      if (location.state?.product) {
        let productFromState = { ...location.state.product };
        productFromState.vendorId = productFromState.vendorId?._id || productFromState.vendorId || "";
        productFromState.categoryId = productFromState.categoryId?._id || productFromState.categoryId || "";
        productFromState.unitTypeId = productFromState.unitTypeId?._id || productFromState.unitTypeId || "";
        productFromState.gallery = productFromState.gallery || [];
        productFromState.availability = productFromState.availability || { homeDelivery: false, storePickup: false };
        productFromState.available_days = productFromState.available_days || [];
        productFromState.available_time = productFromState.available_time || { startTime: "", endTime: "" };
        productFromState.seo = productFromState.seo || { title: "", description: "", keywords: "", ogImage: "" };
        productFromState.features = Array.isArray(productFromState.features) ? productFromState.features : [];
        productFromState.featureDetails = productFromState.featureDetails || {};
        productFromState.price = Number(productFromState.price) || 0;
        productFromState.priceDiscount = Number(productFromState.priceDiscount) || 0;
        productFromState.priceDiscounted = Number(productFromState.priceDiscounted) || 0;
        productFromState.storePrice = Number(productFromState.storePrice) || 0;
        productFromState.openingStock = Number(productFromState.openingStock) || 0;
        productFromState.currentStock = Number(productFromState.currentStock) || 0;
        productFromState.buttonText = productFromState.buttonText || '';
        productFromState.buttonLink = productFromState.buttonLink || '';
        productFromState.detailedDescription = productFromState.detailedDescription || '';
        this.setState({ product: productFromState });
      }
      this.getProduct(productId);
    }
    // Get vendors
    if (user.role === params.user.roles.vendor.key && !productId) {
      const { product } = this.state;
      product.vendorId = user._id;
      this.setState({
        product,
        vendorIndustryType: user.industryType || '',
        isLoading: false
      });
      this.props.fetchUserDetail({ userId: user._id })
        .then(({ data }) => {
          const userObj = data?.data?.user || data?.data?.userDetail;
          if (userObj?.industryType) {
            this.setState({ vendorIndustryType: userObj.industryType });
          }
        })
        .catch(err => console.error("Error fetching vendor user detail:", err));
    } else {
      this.setState({ isLoading: true });
      this.getVendors();
    }

    if ((this.state.isPickupAtStore === null || this.state.isHomeDelivery === null) && !location.state?.isPickupAtStore) {
      this.fetchSettings();
    }
  }

  fetchSettings = async () => {
    const { fetchSettingDetail } = this.props;
    try {
      const { data } = await fetchSettingDetail({ vendorId: "" });
      if (data.success && data.data) {
        const isPickupAtStore = data.data.isPickupAtStore;
        const isHomeDelivery = data.data.isHomeDelivery;
        this.setState({ isPickupAtStore, isHomeDelivery });
      }
    } catch (error) {
      console.error("Error fetching setting details:", error);
    }
  };
  verifyPermissions = async () => {
    const modulePermission = await checkPermission("store", "products");
    this.setState({ permissions: { canEdit: modulePermission.canEdit, canDelete: modulePermission.canDelete, canCreate: modulePermission.canCreate, canView: modulePermission.canView } });
  };
  handleClose = () => this.setState({ purchaseCount: 0, purchaseShow: false });
  handleShow = () => this.setState({ purchaseCount: 0, purchaseShow: true });
  getVendors = async () => {
    const { listVendorsAll, messageShow } = this.props;

    try {
      const { data } = await listVendorsAll();

      if (data.success) {
        const vendors = data.data || [];

        this.setState((prevState) => {
          const product = { ...prevState.product };
          let vendorIndustryType = prevState.vendorIndustryType;

          if (product.vendorId) {
            const selected = vendors.find((v) => v._id === product.vendorId);
            if (selected?.industryType) {
              vendorIndustryType = selected.industryType;
            }
          } else if (vendors.length > 0) {
            product.vendorId = vendors[0]._id;
            vendorIndustryType = vendors[0].industryType || '';
          }

          return {
            vendors,
            product,
            vendorIndustryType,
            isLoading: false
          };
        });
      } else {
        messageShow(data.message);
        this.setState({ isLoading: false });
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
      messageShow("There was some error. Please try again.");
      this.setState({ isLoading: false });
    }
  };

  getCategories = () => {
    const { listCategories } = this.props;

    listCategories();
  };


  fetchUnitTypes = async () => {
    const { getUnitType, messageShow } = this.props;
    try {
      const { data } = await getUnitType();
      if (data.success) {
        this.setState({ unitTypes: data.data });
      } else {
        console.error("Failed to fetch unit types.");
      }
    }
    catch (error) {
      messageShow("There was some error. Please try again");
      console.error("Error fetching unit types:", error);
    }
  };

  normalizeFeatureDetails = (featureDetails) => {
    if (!featureDetails) return {};
    if (featureDetails instanceof Map) {
      const details = {};
      featureDetails.forEach((val, key) => { details[key] = val; });
      return details;
    }
    if (typeof featureDetails === 'object') {
      return { ...featureDetails };
    }
    return {};
  };

  calculateInitialPrice = (product, vendorIndustryType) => {
    const ind = (vendorIndustryType || "").trim().toLowerCase();
    const isRest = ind !== "business" && ind !== "saas";
    if (!isRest) {
      const basePrice = Number.parseFloat(product.price || product.storePrice || product.onlinePrice || 0) || 0;
      const discount = Number.parseFloat(product.priceDiscount || 0) || 0;
      product.price = basePrice;
      product.priceDiscounted = discount > 0 ? (basePrice - (basePrice * discount / 100)).toFixed(2) : basePrice.toFixed(2);
    }
  };

  getProduct = async (productId) => {
    const { details, messageShow } = this.props;

    this.isLoadingToggle(true);

    try {
      const { data } = await details({ productId });

      if (data.success) {
        let product = data.data.productDetails;
        let onlinepercentage = data.data.settingsData.onlinePricingPercentage;
        let timezone = data.data.settingsData.timeZone || 'UTC';
        const vendorIndustryType = product.vendorId?.industryType || '';

        // Ensure availability fields exist
        product.availability = product.availability || { homeDelivery: false, storePickup: false };
        product.available_days = product.available_days || [];
        product.available_time = product.available_time || { startTime: "", endTime: "" };
        product.seo = product.seo || { title: "", description: "", keywords: "", ogImage: "" };
        product.features = Array.isArray(product.features) ? product.features : [];
        product.featureDetails = this.normalizeFeatureDetails(product.featureDetails);

        product.vendorId = product.vendorId?._id || product.vendorId || '';
        product.categoryId = product.categoryId?._id || product.categoryId || '';
        product.unitTypeId = product.unitTypeId ? (product.unitTypeId._id || product.unitTypeId) : '';
        product.buttonText = product.buttonText || '';
        product.buttonLink = product.buttonLink || '';
        product.detailedDescription = product.detailedDescription || '';

        this.calculateInitialPrice(product, vendorIndustryType);

        this.setState({
          product,
          onlinepercentage,
          timezone,
          vendorIndustryType
        });
      }
    } catch (error) {
      console.error("Error getting product detail:", error);
      messageShow("There was some error. Please try again");
    } finally {
      this.isLoadingToggle(false);
    }
  };

  validateNonBusinessFields = (product, errors) => {
    const storePriceVal = Number(product?.storePrice);
    const onlinePriceVal = Number(product?.price);
    const openingStockNum = Number(product?.openingStock);

    if (Number.isNaN(storePriceVal) || storePriceVal <= 0) {
      errors.storePrice = "Please enter a valid price";
    }
    if (Number.isNaN(onlinePriceVal) || onlinePriceVal <= 0) {
      errors.price = "Please enter a valid price";
    }
    if (!product?.unitTypeId) {
      errors.unitTypeId = "Please fill out this field.";
    }
    if (product?.openingStock === "" || Number.isNaN(openingStockNum) || openingStockNum < 0) {
      errors.openingStock = "Please enter valid opening stock";
    }
  };

  collectProductValidationErrors = (product, isBusiness, isAdmin) => {
    const errors = {};

    if (isAdmin && !product?.vendorId) {
      errors.vendorId = "Please fill out this field.";
    }
    if (!product?.name?.trim()) {
      errors.name = "Please fill out this field.";
    }
    if (!product?.slug?.trim()) {
      errors.slug = "Please fill out this field.";
    }
    if (isBusiness && !product?.brand?.trim()) {
      errors.brand = "Please fill out this field.";
    }
    if (!product?.categoryId) {
      errors.categoryId = "Please fill out this field.";
    }
    if (!product?.description?.trim()) {
      errors.description = "Please fill out this field.";
    }

    if (product?.priceDiscount !== undefined && product?.priceDiscount !== null && product?.priceDiscount !== "") {
      const discountVal = Number(product.priceDiscount);
      if (Number.isNaN(discountVal) || discountVal < 0 || discountVal > 100) {
        errors.priceDiscount = "Please enter a value between 0 and 100.";
      }
    }

    if (!isBusiness) {
      this.validateNonBusinessFields(product, errors);
    }
    return errors;
  };

  focusFirstErrorInput = (errors, isBusiness) => {
    const order = isBusiness
      ? ["name", "slug", "brand", "vendorId", "categoryId", "description", "priceDiscount"]
      : ["name", "slug", "brand", "vendorId", "categoryId", "description", "priceDiscount", "storePrice", "price", "unitTypeId", "openingStock"];

    const firstErrorKey = order.find((k) => errors[k]) || Object.keys(errors)[0];

    this.setState({ errors, activeErrorField: firstErrorKey });

    const targetEl =
      document.querySelector(`input[name="${firstErrorKey}"]:not([type="hidden"]), textarea[name="${firstErrorKey}"]`) ||
      document.querySelector(`[aria-labelledby*="${firstErrorKey}"]`) ||
      document.getElementById(firstErrorKey)?.parentElement?.querySelector('[role="button"]') ||
      document.getElementById(firstErrorKey);

    if (targetEl) {
      const container = targetEl.closest('.MuiFormControl-root') || targetEl;
      const elementTop = container.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0);

      if (elementTop < 700) {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      } else {
        const targetY = Math.max(0, elementTop - 120);
        window.scrollTo({ top: targetY, left: 0, behavior: 'smooth' });
      }
      targetEl.focus();
    }
  };

  validateProductInput = (product, isBusiness) => {
    const { auth: { user } } = this.props;
    const isAdmin = user?.role === params.user.roles.admin.key;
    const errors = this.collectProductValidationErrors(product, isBusiness, isAdmin);

    if (Object.keys(errors).length > 0) {
      this.focusFirstErrorInput(errors, isBusiness);
      return false;
    }
    return true;
  };

  buildProductPayload = (product, isRestaurant, isUpdate) => {
    return {
      ...product,
      brand: isRestaurant ? (product.brand || "Restaurant") : (product.brand || ""),
      price: !isRestaurant ? (Number(product.price) || Number(product.storePrice) || Number(product.onlinePrice) || 0) : product.price,
      storePrice: !isRestaurant ? (Number(product.storePrice) || Number(product.price) || 0) : product.storePrice,
      onlinePrice: !isRestaurant ? (Number(product.onlinePrice) || Number(product.storePrice) || 0) : product.onlinePrice,
      openingStock: !isRestaurant ? (Number(product.openingStock) || 0) : product.openingStock,
      currentStock: !isRestaurant ? (Number(product.currentStock) || 0) : product.currentStock,
      unit: !isRestaurant ? (product.unit || "pcs") : product.unit,
      buttonText: product.buttonText || "",
      buttonLink: product.buttonLink || "",
      seo: {
        ...product.seo,
        title: product.name,
        description: product.description
      },
      action: isUpdate ? 'update' : 'add'
    };
  };

  onCreateOrUpdate = async (event) => {
    event.preventDefault();

    const { createOrUpdate, messageShow, match: { params: { productId } } } = this.props;
    const { product, vendorIndustryType } = this.state;
    const isUpdate = productId || product._id;

    const indType = (vendorIndustryType || "").trim().toLowerCase();
    const isBusiness = indType === "business" || indType === "saas";
    const isRestaurant = !isBusiness;

    if (!this.validateProductInput(product, isBusiness)) {
      return;
    }

    this.isLoadingSubmitToggle(true);

    try {
      const payload = this.buildProductPayload(product, isRestaurant, isUpdate);
      const { data } = await createOrUpdate({ product: payload });

      this.isLoadingSubmitToggle(false);

      if (!data?.success) {
        const errorMsg = data?.message || "There was some error. Please try again.";
        messageShow(errorMsg);
        if (errorMsg.toLowerCase().includes("brand")) {
          this.setState(prevState => ({
            errors: { ...prevState.errors, brand: errorMsg }
          }));
          const brandEl = document.querySelector('[name="brand"]') || document.getElementById("brand");
          if (brandEl) {
            brandEl.focus();
            brandEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
        return;
      }

      messageShow(data.message);
      this.back();
    } catch (error) {
      console.error("Error creating/updating product:", error);
      this.isLoadingSubmitToggle(false);
      const errorMsg = error?.message || "Some error occurred. Please try again.";
      messageShow(errorMsg);
      if (errorMsg.toLowerCase().includes("brand")) {
        this.setState(prevState => ({
          errors: { ...prevState.errors, brand: errorMsg }
        }));
        const brandEl = document.querySelector('[name="brand"]') || document.getElementById("brand");
        if (brandEl) {
          brandEl.focus();
          brandEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }
  };

  handleUnitTypeChange = (event) => {
    const { product, errors } = this.state;
    product.unitTypeId = event.target.value;
    const updatedErrors = errors ? { ...errors } : {};
    if (updatedErrors.unitTypeId) {
      delete updatedErrors.unitTypeId;
    }
    this.setState({ product, errors: updatedErrors });
  };

  isLoadingToggle = (isLoading) => {
    this.setState({
      isLoading,
    });
  };

  isLoadingSubmitToggle = (isLoadingSubmit) => {
    this.setState({
      isLoadingSubmit,
    });
  };

  isUploadingFileToggle = (isUploadingFile) => {
    this.setState({
      isUploadingFile,
    });
  };

  onTypePopup = ({ target: { value } }) => {
    this.setState({ purchaseCount: value });
  };

  updatePurchaseCount = async (event) => {
    let { product, purchaseCount } = this.state;
    const {
      match: {
        params: { productId },
      },
    } = this.props;

    // Check if adding this purchase would set currentStock to 0
    if (product.currentStock + +purchaseCount === 0) {
      const confirmation = window.confirm("Are you sure you want to allow currentStock to be 0?");
      if (!confirmation) {
        return; // Prevent the update if user cancels
      }
    }

    product["purchase"] = (product["purchase"] ? product["purchase"] : 0) + +purchaseCount;
    this.setState({ purchaseShow: false, product: product });
    const { productPurchase } = this.props;
    await productPurchase({
      purchaseCount: purchaseCount,
      productId: productId,
    });
  };

  calculateDiscountedPrice = (basePrice, discount) => {
    const numBase = Number.parseFloat(basePrice) || 0;
    const numDiscount = Number.parseFloat(discount) || 0;
    if (numDiscount > 100 || numDiscount < 0) {
      return numBase.toFixed(2);
    }
    if (numDiscount > 0) {
      const discounted = numBase - (numBase * (numDiscount / 100));
      const rounded = Math.round(discounted * 100) / 100;
      return Number.isNaN(rounded) ? "0.00" : Math.max(0, rounded).toFixed(2);
    }
    const rounded = Math.round(numBase * 100) / 100;
    return Number.isNaN(rounded) ? "0.00" : rounded.toFixed(2);
  };

  handleProductFieldChange = (product, name, value) => {
    if (name === "name") {
      product.slug = value.toLowerCase().replaceAll(' ', '-');
      product.name = value.charAt(0).toUpperCase() + value.slice(1);
    } else if (name === "slug") {
      product.slug = value;
    } else if (name.startsWith("seo.")) {
      const seoField = name.split(".")[1];
      product.seo = product.seo || {};
      product.seo[seoField] = value;
    } else {
      product[name] = typeof value === 'string' && value.length > 0
        ? value.charAt(0).toUpperCase() + value.slice(1)
        : value;
    }
  };

  calculatePricingUpdates = (product, name, value, onlinepercentage, isRestaurant) => {
    if (name === "price" || name === "priceDiscount") {
      const basePrice = product.price || product.storePrice || 0;
      const discount = name === "priceDiscount" ? value : product.priceDiscount;
      product.priceDiscounted = this.calculateDiscountedPrice(basePrice, discount);
    }

    if (name === "storePrice" || name === "onlinePrice" || name === "onlinepercentage") {
      if (name === "storePrice") {
        product.onlinePrice = value;
      }
      const storePrice = Number.parseFloat(product.storePrice) || 0;
      const pct = Number.parseFloat(onlinepercentage) || 0;

      if (isRestaurant && pct !== 0) {
        const calculatedPrice = storePrice + (storePrice * (pct / 100));
        const rounded = Math.round(calculatedPrice * 100) / 100;
        product.price = Number.isNaN(rounded) ? "0.00" : rounded.toFixed(2);
      } else {
        product.price = storePrice;
      }

      product.priceDiscounted = this.calculateDiscountedPrice(product.price, product.priceDiscount);
    }
  };

  validatePriceDiscountOnType = (value, errors, activeErrorField) => {
    if (value !== "" && value !== null && value !== undefined) {
      const num = Number(value);
      if (Number.isNaN(num) || num < 0 || num > 100) {
        errors.priceDiscount = "Please enter a value between 0 and 100.";
        return "priceDiscount";
      }
    }
    delete errors.priceDiscount;
    return activeErrorField === "priceDiscount" ? null : activeErrorField;
  };

  resolveActiveErrorFieldOnType = (name, value, errors, activeErrorField) => {
    if (name === "priceDiscount") {
      return this.validatePriceDiscountOnType(value, errors, activeErrorField);
    }
    if (value && typeof value === 'string' && value.trim().length > 0) {
      delete errors[name];
      return activeErrorField === name ? null : activeErrorField;
    }
    return activeErrorField;
  };

  onType = ({ target: { name, value } }) => {
    const { product, onlinepercentage, vendorIndustryType, errors, activeErrorField } = this.state;

    this.handleProductFieldChange(product, name, value);

    const indType = (vendorIndustryType || "").trim().toLowerCase();
    const isRestaurant = indType !== "business" && indType !== "saas";
    this.calculatePricingUpdates(product, name, value, onlinepercentage, isRestaurant);

    const updatedErrors = errors ? { ...errors } : {};
    const newActiveErrorField = this.resolveActiveErrorFieldOnType(name, value, updatedErrors, activeErrorField);

    this.setState({
      product,
      errors: updatedErrors,
      activeErrorField: newActiveErrorField
    });
  };

  onSelect = ({ target: { name, value } }) => {
    const { product, vendors, errors, activeErrorField } = this.state;

    product[name] = value;

    const updatedErrors = errors ? { ...errors } : {};
    let newActiveErrorField = activeErrorField;
    if (value) {
      if (updatedErrors[name]) {
        delete updatedErrors[name];
      }
      if (activeErrorField === name) {
        newActiveErrorField = null;
      }
    }

    if (name === "vendorId") {
      const selectedVendor = vendors.find(v => v._id === value);
      this.setState({
        product,
        errors: updatedErrors,
        activeErrorField: newActiveErrorField,
        vendorIndustryType: selectedVendor?.industryType || ''
      });
      if (value) {
        this.props.fetchUserDetail({ userId: value })
          .then(({ data }) => {
            const userObj = data?.data?.user || data?.data?.userDetail;
            if (userObj?.industryType) {
              this.setState({ vendorIndustryType: userObj.industryType });
            }
          })
          .catch(err => console.error("Error fetching vendor user detail:", err));
      }
    } else {
      this.setState({
        product,
        errors: updatedErrors,
        activeErrorField: newActiveErrorField,
      });
    }
  };

  handleFeatureChange = (index, newTitle) => {
    const { product } = this.state;
    product.features = product.features || [];
    const oldTitle = product.features[index];
    product.features[index] = newTitle;

    product.featureDetails = product.featureDetails || {};
    if (oldTitle && oldTitle !== newTitle) {
      product.featureDetails[newTitle] = product.featureDetails[oldTitle] || '';
      delete product.featureDetails[oldTitle];
    }

    this.setState({ product });
  };

  handleFeatureDetailChange = (featureTitle, detailText) => {
    const { product } = this.state;
    product.featureDetails = product.featureDetails || {};
    product.featureDetails[featureTitle] = detailText;
    this.setState({ product });
  };

  handleAddFeature = () => {
    const { product } = this.state;
    product.features = product.features || [];
    product.features.push('');
    this.setState({ product });
  };

  handleRemoveFeature = (index, featureTitle) => {
    const { product } = this.state;
    product.features = product.features || [];
    product.features.splice(index, 1);
    if (product.featureDetails && featureTitle) {
      delete product.featureDetails[featureTitle];
    }
    this.setState({ product });
  };

  onUpload = async (event) => {
    const { upload, messageShow } = this.props;
    const imgFile = event.target.files?.[0];
    if (!imgFile) return;

    if (imgFile.size > 256000) {
      messageShow("Image size should not exceed 250KB.");
      return;
    }
    messageShow("Uploading file, please wait...");

    this.isUploadingFileToggle(true);

    const file = new FormData();
    file.append("type", "product");
    file.append("name", this.state.product.slug);
    file.append("file", imgFile);

    const fileReader = new FileReader();
    fileReader.onload = () => {
      const fileResult = fileReader.result;
      this.setState({ previewImage: fileResult });
    };
    fileReader.readAsDataURL(imgFile);

    // Upload image
    try {
      const { data } = await upload(file);

      if (data?.success && data?.file) {
        messageShow("File uploaded successfully.");
        const currentProduct = this.state.product || {};
        this.setState({
          product: {
            ...currentProduct,
            image: data.file,
          },
        });
      } else {
        messageShow(data?.message || "There was some error. Please try again.");
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      messageShow("There was some error. Please try again.");
    } finally {
      this.isUploadingFileToggle(false);
    }
  };

  onUploadGallery = async (event) => {
    const { multipleUpload, messageShow } = this.props;

    messageShow("Uploading file, please wait...");

    this.isUploadingFileToggle(true);

    var formdata = new FormData();
    formdata.append("type", "product");

    for (let i = 0; i < Object.keys(event.target.files).length; i++) {
      let file = event.target.files[i];
      formdata.append(`files`, file, file.name);
    }

    // Upload image
    try {
      const { data } = await multipleUpload(formdata);

      if (data.success) {
        messageShow("File uploaded successfully.");

        const { product } = this.state;
        setTimeout(() => {
          product.gallery = data.file;
          this.setState({
            product,
          });
        }, 1500);
      } else {
        messageShow("There was some error. Please try again.");
      }
    } catch (error) {
      console.error("Error uploading gallery images:", error);
      messageShow("There was some error. Please try again.");
    } finally {
      this.isUploadingFileToggle(false);
    }
  };

  back = () => {
    const { history } = this.props;
    history.push(routes.productList.path(1));
    /*if (history.length > 2) {
      history.goBack();
    } else {
      history.push(routes.productList.path(1));
    }*/
  };
  onChange = ({ target: { name, value } }) => {
    const { product } = this.state;
    product[name] = value;
    this.setState({
      product,
    });
  };

  onChangefeature = (event) => {
    const { name, checked } = event.target;
    this.setState((prevState) => ({
      product: {
        ...prevState.product,
        [name]: checked,
      },
    }));
  };


  onChangeLiveCounter = (event) => {
    const isLiveCounterItem = event.target.checked;
    this.setState(prevState => {
      const newAvailability = isLiveCounterItem
        ? { ...prevState.product.availability, storePickup: true }
        : { storePickup: false, homeDelivery: false };

      return {
        product: {
          ...prevState.product,
          isLiveCounterItem,
          availability: newAvailability
        }
      };
    });
  };

  onChangeAvailability = (event) => {
    const { name, checked } = event.target;
    this.setState(prevState => {
      const newAvailability = {
        ...prevState.product.availability,
        [name]: checked
      };
      if (prevState.product.isLiveCounterItem) {
        const otherName = name === "storePickup" ? "homeDelivery" : "storePickup";
        if (!checked && !prevState.product.availability[otherName]) {
          alert("Atleast one delivery method must be selected when Live Counter Product is enabled.");
          return prevState;
        }
      }
      return {
        product: {
          ...prevState.product,
          availability: newAvailability
        }
      };
    });
  };


  onChangeVegOrNonveg(event) {
    const { name, checked } = event.target;
    this.setState((prevState) => ({
      product: {
        ...prevState.product,
        isVeg: name === "isVeg" ? checked : !checked,
        isNonVeg: name === "isNonVeg" ? checked : !checked,
      },
    }));
  }

  onChangeAvailableDays = (day) => {
    this.setState((prevState) => {
      const { available_days } = prevState.product;
      const newDays = available_days.includes(day)
        ? available_days.filter(d => d !== day)
        : [...available_days, day];

      return {
        product: {
          ...prevState.product,
          available_days: newDays
        }
      };
    });
  };

  handleSelectAllDays = (event, checked) => {
    const allDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    this.setState(prevState => ({
      product: {
        ...prevState.product,
        available_days: checked ? allDays : []
      }
    }));
  };

  onChangeAvailableTime = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      product: {
        ...prevState.product,
        available_time: {
          ...prevState.product.available_time,
          [name]: value
        }
      },
    }));
  };

  renderBusinessForm = () => {
    const {
      auth: { user },
      match: {
        params: { productId },
      },
      categories,
    } = this.props;
    const { vendors, product, previewImage, errors, activeErrorField, isLoadingSubmit, isUploadingFile, permissions } = this.state;

    return (
      <BusinessForm
        product={product}
        errors={errors || {}}
        activeErrorField={activeErrorField}
        previewImage={previewImage}
        vendors={vendors}
        categories={categories}
        permissions={permissions}
        isAdmin={user.role === params.user.roles.admin.key}
        productId={productId}
        onType={this.onType}
        onSelect={this.onSelect}
        handleFeatureChange={this.handleFeatureChange}
        handleFeatureDetailChange={this.handleFeatureDetailChange}
        handleAddFeature={this.handleAddFeature}
        handleRemoveFeature={this.handleRemoveFeature}
        onChangePublished={(e) => this.onChangefeature({ target: { name: 'isPublished', checked: e.target.checked } })}
        onChangeFeatured={(e) => this.onChangefeature({ target: { name: 'isFeatured', checked: e.target.checked } })}
        onUpload={this.onUpload}
        onSubmit={this.onCreateOrUpdate}
        back={this.back}
        isLoadingSubmit={isLoadingSubmit}
        isUploadingFile={isUploadingFile}
      />
    );
  };

  renderVendorField = (user, vendors, product, errors, classes, activeErrorField) => {
    if (user.role !== params.user.roles.admin.key) return null;
    return (
      <Grid item xs={12} style={{ position: "relative" }}>
        <FormControl
          fullWidth
          className={classes.select}
          error={Boolean(errors.vendorId)}
        >
          <InputLabel htmlFor="vendorId" required>Vendor</InputLabel>
          <Select
            value={nullToEmptyString(product.vendorId)}
            onChange={this.onSelect}
            inputProps={{
              name: "vendorId",
              id: "vendorId",
            }}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {vendors.length > 0 &&
              vendors.map((item) => (
                <MenuItem
                  key={item._id}
                  value={item._id}
                >{`${item.name} (${item.email})`}</MenuItem>
              ))}
          </Select>
          {errors.vendorId && <FormHelperText error>{errors.vendorId}</FormHelperText>}
        </FormControl>
        {activeErrorField === "vendorId" && (
          <ValidationTooltip message={errors.vendorId || "Please fill out this field."} />
        )}
      </Grid>
    );
  };

  renderCategoryField = (categories, product, errors, classes, activeErrorField) => (
    <Grid item xs={12} style={{ position: "relative" }}>
      <FormControl
        fullWidth
        className={classes.select}
        error={Boolean(errors.categoryId)}
      >
        <InputLabel htmlFor="categoryId" required>Category</InputLabel>
        <Select
          value={nullToEmptyString(product.categoryId)}
          onChange={this.onSelect}
          inputProps={{
            name: "categoryId",
            id: "categoryId",
          }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {categories.isLoading ? (
            <MenuItem disabled>
              <em>loading</em>
            </MenuItem>
          ) : (
            categories.list.map(({ category, subCategories }) => [
              <MenuItem
                key={category._id}
                value={category._id}
                disabled
              >
                {category.name}
              </MenuItem>,
              subCategories.map((subCategory) => (
                <MenuItem
                  key={subCategory._id}
                  value={subCategory._id}
                  style={{ paddingLeft: 40 }}
                >
                  {subCategory.name}
                </MenuItem>
              )),
            ])
          )}
        </Select>
        {errors.categoryId && <FormHelperText error>{errors.categoryId}</FormHelperText>}
      </FormControl>
      {activeErrorField === "categoryId" && (
        <ValidationTooltip message={errors.categoryId || "Please fill out this field."} />
      )}
    </Grid>
  );

  renderVegOrNonVeg = (product, permissions) => (
    <>
      <b> Veg Or NonVeg </b>
      <Grid container spacing={12}>
        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Checkbox
                checked={product.isVeg}
                onChange={permissions.canEdit && this.onChangeVegOrNonveg}
                name="isVeg"
                color="primary"
                margin={"normal"}
                autoComplete={"off"}
                disabled={!permissions.canEdit}
                fullWidth
              />
            }
            label="Veg"
          />
        </Grid>
        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Checkbox
                checked={product.isNonVeg}
                onChange={this.onChangeVegOrNonveg}
                name="isNonVeg"
                color="primary"
                margin={"normal"}
                autoComplete={"off"}
                disabled={!permissions.canEdit}
                fullWidth
              />
            }
            label="Non Veg"
          />
        </Grid>
      </Grid>
    </>
  );

  renderLiveCounterAndAvailability = (product, permissions, isPickupAtStore, isHomeDelivery) => (
    <>
      <b> Live Counter Item </b>
      <Grid container spacing={12}>
        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Checkbox
                checked={product.isLiveCounterItem}
                onChange={this.onChangeLiveCounter}
                name="isLiveCounterItem"
                color="primary"
                margin="normal"
                autoComplete="off"
                disabled={!permissions.canEdit}
                fullWidth
              />
            }
            label="Enable Live Counter"
          />
        </Grid>
      </Grid>
      <Grid container spacing={12}>
        {isPickupAtStore && (
          <Grid item xs={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={product.availability.storePickup}
                  onChange={this.onChangeAvailability}
                  name="storePickup"
                  color="primary"
                  margin={"normal"}
                  autoComplete={"off"}
                  disabled={!product.isLiveCounterItem || !permissions.canEdit}
                  fullWidth
                />
              }
              label="Pickup At Store"
            />
          </Grid>
        )}
        {isHomeDelivery && (
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={product.availability.homeDelivery}
                  onChange={this.onChangeAvailability}
                  name="homeDelivery"
                  color="primary"
                  margin={"normal"}
                  autoComplete={"off"}
                  disabled={!permissions.canEdit || !product.isLiveCounterItem}
                  fullWidth
                />
              }
              label="Home Delivery"
            />
          </Grid>
        )}
      </Grid>

      {/* Deal Availability Control */}
      <b>Deal Availability Control</b>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="subtitle2">Available Days (Leave empty for all days)</Typography>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={3} sm={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={product.available_days && product.available_days.length === 7}
                        onChange={this.handleSelectAllDays}
                        color="primary"
                      />
                    }
                    label="Select All"
                  />
                </Grid>
                {['Sunday', 'Monday', 'Tuesday'].map(day => (
                  <Grid item key={day} xs={3} sm={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={product.available_days && product.available_days.includes(day)}
                          onChange={() => this.onChangeAvailableDays(day)}
                          color="primary"
                        />
                      }
                      label={day}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container>
                {['Wednesday', 'Thursday', 'Friday', 'Saturday'].map(day => (
                  <Grid item key={day} xs={3} sm={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={product.available_days && product.available_days.includes(day)}
                          onChange={() => this.onChangeAvailableDays(day)}
                          color="primary"
                        />
                      }
                      label={day}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TimePicker
            label="Start Time"
            value={
              product.available_time?.startTime
                ? dayjs(product.available_time.startTime, "HH:mm")
                : null
            }
            onChange={(newValue) => {
              const val = newValue ? newValue.format("HH:mm") : "";
              this.setState((prevState) => ({
                product: {
                  ...prevState.product,
                  available_time: {
                    ...prevState.product.available_time,
                    startTime: val,
                  },
                },
              }));
            }}
            slotProps={{
              actionBar: {
                actions: ["clear", "cancel", "accept"],
              },
              textField: { size: "small", variant: "standard" },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TimePicker
            label="End Time"
            value={
              product.available_time?.endTime
                ? dayjs(product.available_time.endTime, "HH:mm")
                : null
            }
            onChange={(newValue) => {
              const val = newValue ? newValue.format("HH:mm") : "";
              this.setState((prevState) => ({
                product: {
                  ...prevState.product,
                  available_time: {
                    ...prevState.product.available_time,
                    endTime: val,
                  },
                },
              }));
            }}
            slotProps={{
              actionBar: {
                actions: ["clear", "cancel", "accept"],
              },
              textField: { size: "small", variant: "standard" },
            }}
          />
        </Grid>
      </Grid>
    </>
  );

  renderPricingAndStockFields = (product, errors, isServiceOrSaaS, unitTypes, classes, productId, activeErrorField) => (
    <>
      <Grid container spacing={8}>
        {/* store price */}
        <Grid item xs={4}>
          <TextField
            type={"number"}
            name={"storePrice"}
            value={nullToEmptyString(product.storePrice)}
            onChange={this.onType}
            label={"Store Price"}
            placeholder={"Enter Store price "}
            required={!isServiceOrSaaS}
            error={Boolean(errors.storePrice)}
            helperText={errors.storePrice || ""}
            margin={"dense"}
            autoComplete={"off"}
            fullWidth
          />
        </Grid>
        {/* Input - Price */}
        <Grid item xs={4}>
          <TextField
            type={"number"}
            name={"price"}
            value={nullToEmptyString(product.price)}
            onChange={this.onType}
            label={"Online Price"}
            placeholder={"Enter Online price"}
            required={!isServiceOrSaaS}
            error={Boolean(errors.price)}
            helperText={errors.price || ""}
            margin={"dense"}
            autoComplete={"off"}
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container spacing={8}>
        {/* Input - Discount */}
        <Grid item xs={4} style={{ position: "relative" }}>
          <TextField
            type={"number"}
            name={"priceDiscount"}
            id={"priceDiscount"}
            value={nullToEmptyString(product.priceDiscount)}
            onChange={this.onType}
            onKeyDown={(e) => {
              if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                e.preventDefault();
              }
            }}
            label={"Discount in %"}
            placeholder={"Enter discount in %"}
            margin={"dense"}
            autoComplete={"off"}
            inputProps={{ min: 0, max: 100 }}
            error={Boolean(errors.priceDiscount)}
            helperText={errors.priceDiscount || ""}
            fullWidth
          />
          {activeErrorField === "priceDiscount" && (
            <ValidationTooltip message={errors.priceDiscount || "Please enter a value between 0 and 100."} />
          )}
        </Grid>

        {/* Input - Discounted price */}
        <Grid item xs={4}>
          <TextField
            type={"number"}
            name={"priceDiscounted"}
            value={nullToEmptyString(product.priceDiscounted)}
            label={"Discounted Price"}
            margin={"dense"}
            autoComplete={"off"}
            disabled
            fullWidth
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} className={classes.buttonUpload}>
        <Grid item xs={4}>
          {/* Input - Unit */}
          <TextField
            name={"unit"}
            value={nullToEmptyString(product.unit)}
            onChange={this.onType}
            label={"Unit"}
            placeholder={"Enter unit (eg: kg)"}
            required={true}
            margin={"dense"}
            autoComplete={"off"}
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
          <FormControl fullWidth margin={"dense"} error={Boolean(errors.unitTypeId)}>
            <InputLabel required>Unit Type</InputLabel>
            <Select
              name={"unitType"}
              value={product.unitTypeId ? product.unitTypeId : ''}
              onChange={this.handleUnitTypeChange}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 200,
                  },
                },
              }}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {unitTypes && unitTypes.length > 0 ? (
                unitTypes.map((unitType) => (
                  <MenuItem key={unitType._id} value={unitType._id}>
                    {unitType.name}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>
                  No unit types found
                </MenuItem>
              )}
            </Select>
            {errors.unitTypeId && <FormHelperText error>{errors.unitTypeId}</FormHelperText>}
          </FormControl>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        {/* Input - openingStock */}
        <TextField
          name={"openingStock"}
          value={nullToEmptyString(product.openingStock)}
          onChange={this.onType}
          label={"Opening Stock"}
          placeholder={"Enter Opening Stock (eg: 10)"}
          required={true}
          error={Boolean(errors.openingStock)}
          helperText={errors.openingStock || ""}
          margin={"dense"}
          autoComplete={"off"}
          fullWidth
          disabled={Boolean(productId)}
        />
      </Grid>
      <Grid item xs={12}>
        {/* Input - Current Stock */}
        <TextField
          name={"currentStock"}
          value={nullToEmptyString(product.currentStock)}
          onChange={this.onType}
          label={"Current Stock"}
          placeholder={"Enter Current Stock (eg: 10)"}
          required={true}
          margin={"dense"}
          autoComplete={"off"}
          fullWidth
          disabled={Boolean(productId)}
        />
      </Grid>
      {productId ? (
        <Grid container spacing={10} className={classes.buttonUpload}>
          <Grid item xs={7}>
            {/* Input - Unit */}
            <TextField
              name={"purchase"}
              value={nullToEmptyString(product.purchase)}
              onChange={this.onType}
              label={"Added Stock"}
              placeholder={"Added Stock (eg: 100)"}
              required={true}
              margin={"dense"}
              autoComplete={"off"}
              disabled={true}
            />
          </Grid>

          <Grid item xs={4}>
            {/* Input - Can Subscribe */}
            <Button variant="primary" onClick={this.handleShow}>
              Restock
            </Button>
          </Grid>
        </Grid>
      ) : null}
    </>
  );

  render() {
    const {
      auth: { user },
      match: {
        params: { productId },
      },
      categories,
      classes,
    } = this.props;
    const { vendors, unitTypes, product, errors = {}, activeErrorField, isLoading, isLoadingSubmit, isUploadingFile, isPickupAtStore, isHomeDelivery, permissions, vendorIndustryType } =
      this.state;

    if (isLoading) {
      return (
        <div style={{ padding: 40, textAlign: 'center' }}>
          <BrandedLoading />
        </div>
      );
    }

    const indType = (vendorIndustryType || "").trim().toLowerCase();
    const isBusiness = indType === "business" || indType === "saas";
    const isRestaurant = !isBusiness;
    const isServiceOrSaaS = indType !== "" && !isRestaurant;

    if (isBusiness) {
      return this.renderBusinessForm();
    }

    return (
      <div>
        <Toolbar className={classes.toolbar}>
          <IconButton
            className={classes.menuButton}
            color="inherit"
            onClick={this.back}
          >
            <IconArrowBack />
          </IconButton>

          <Typography variant="h6" color="inherit" className={classes.grow}>
            {productId ? "Edit" : "Create"} Product
          </Typography>
        </Toolbar>

        <Grid item xs={12} lg={6}>
          <SectionPaper padding>
            {isLoading ? (
              <BrandedLoading />
            ) : (
              <form onSubmit={this.onCreateOrUpdate} noValidate>
                {/* Input - Name */}
                <Grid item xs={12} style={{ position: "relative" }}>
                  <TextField
                    name={"name"}
                    value={nullToEmptyString(product.name)}
                    onChange={this.onType}
                    label={"Name"}
                    placeholder={"Enter product name"}
                    required={true}
                    error={Boolean(errors.name)}
                    helperText={errors.name || ""}
                    margin={"dense"}
                    autoComplete={"off"}
                    fullWidth
                    autoFocus
                  />
                  {activeErrorField === "name" && (
                    <ValidationTooltip message={errors.name || "Please fill out this field."} />
                  )}
                </Grid>

                {/* Input - Slug */}
                <Grid item xs={12} style={{ position: "relative" }}>
                  <TextField
                    name={"slug"}
                    value={nullToEmptyString(product.slug)}
                    onChange={this.onType}
                    label={"Slug"}
                    placeholder={"Enter slug"}
                    required={true}
                    margin={"normal"}
                    autoComplete={"off"}
                    fullWidth
                  />
                  {activeErrorField === "slug" && (
                    <ValidationTooltip message={errors.slug || "Please fill out this field."} />
                  )}
                </Grid>

                {/* Input - Brand */}
                <Grid item xs={12}>
                  <TextField
                    name={"brand"}
                    value={nullToEmptyString(product.brand)}
                    onChange={this.onType}
                    label={"Brand"}
                    placeholder={"Enter brand name"}
                    required={false}
                    margin={"normal"}
                    autoComplete={"off"}
                    fullWidth
                  />
                </Grid>

                {/* Input - Vendors */}
                {this.renderVendorField(user, vendors, product, errors, classes, activeErrorField)}

                {/* Input - Categories */}
                {this.renderCategoryField(categories, product, errors, classes, activeErrorField)}

                {/* Input - Description */}
                <Grid item xs={12} style={{ position: "relative" }}>
                  <TextField
                    name={"description"}
                    value={nullToEmptyString(product.description)}
                    onChange={this.onType}
                    label={"Description"}
                    placeholder={"Enter description"}
                    margin={"dense"}
                    autoComplete={"off"}
                    required={true}
                    error={Boolean(errors.description)}
                    helperText={errors.description || ""}
                    multiline
                    rows={3}
                    fullWidth
                  />
                  {activeErrorField === "description" && (
                    <ValidationTooltip message={errors.description || "Please fill out this field."} />
                  )}
                </Grid>

                {/* SEO Optimization - Only Keywords now */}
                <Grid item xs={12} style={{ marginTop: 16 }}>
                  <Typography variant="subtitle1" style={{ fontWeight: 600 }}>SEO Optimization</Typography>
                  <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
                    Keywords will be used for search engines.
                  </Typography>
                  <TextField
                    name="seo.keywords"
                    value={nullToEmptyString(product.seo?.keywords)}
                    onChange={this.onType}
                    label="SEO Keywords"
                    placeholder="e.g. food, delivery, branch"
                    margin="dense"
                    autoComplete="off"
                    fullWidth
                  />
                </Grid>

                {/* veg or nonveg */}
                {isRestaurant && this.renderVegOrNonVeg(product, permissions)}

                {/* publish and featured */}
                <Grid container spacing={12}>
                  <Grid item xs={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={product.isPublished}
                          onChange={this.onChangefeature}
                          name="isPublished"
                          color="primary"
                          margin={"normal"}
                          autoComplete={"off"}
                          disabled={!permissions.canEdit}
                          fullWidth
                        />
                      }
                      label="Published"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={product.isFeatured}
                          onChange={this.onChangefeature}
                          name="isFeatured"
                          color="primary"
                          margin={"normal"}
                          autoComplete={"off"}
                          disabled={!permissions.canEdit}
                          fullWidth
                        />
                      }
                      label="Featured"
                    />
                  </Grid>
                </Grid>

                {/* Live Counter & Availability */}
                {isRestaurant && this.renderLiveCounterAndAvailability(product, permissions, isPickupAtStore, isHomeDelivery)}

                {/* Pricing and Stock */}
                {!isServiceOrSaaS && this.renderPricingAndStockFields(product, errors, isServiceOrSaaS, unitTypes, classes, productId, activeErrorField)}

                {/* Input - Image */}
                <Grid container spacing={1} className={classes.imageUpload}>
                  <Grid item>
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
                      Recommended size: 300px × 300px
                    </Typography>
                  </Grid>
                  <Grid item sm={6}>
                    <div style={{ marginBottom: 20 }}>
                      <input
                        accept={"image/png,image/jpeg"}
                        style={{ display: "none" }}
                        id={"contained-button-file"}
                        type={"file"}
                        onChange={this.onUpload}
                        disabled={!product.slug}
                      />

                      <label htmlFor={"contained-button-file"}>
                        <Button
                          variant={"outlined"}
                          component={"span"}
                          type={"file"}
                          disabled={isUploadingFile || !product.slug || !permissions.canEdit}
                          fullWidth
                        >
                          Upload Primary Image
                        </Button>
                      </label>
                    </div>
                    {!this.state.previewImage ? (
                      <ImageComp
                        src={getImageSource(`${product.image}`)}
                        defaultSrc={getImageSource()}
                        size={150}
                      />
                    ) : (
                      <img
                        height="auto"
                        width="100%"
                        src={this.state.previewImage}
                        alt="preview_product"
                        onError={e => {
                          e.target.onerror = null;
                          e.target.src = getImageSource();
                        }}
                      ></img>
                    )}
                  </Grid>

                  {/* Gallery */}
                  {/* <Grid item sm={6}>
                      <div style={{ marginBottom: 20 }}>
                        <input
                          accept={'image/png,image/jpeg'}
                          style={{ display: 'none' }}
                          id={'contained-button-file-gallery'}
                          type={'file'}
                          multiple
                          onChange={this.onUploadGallery}
                        />

                        <label htmlFor={'contained-button-file-gallery'}>
                          <Button
                            variant={'outlined'}
                            component={'span'}
                            type={'file'}
                            disabled={isUploadingFile}
                            fullWidth
                          >
                            Upload Gallery Image
                            </Button>
                        </label>
                      </div>

                      {
                        product.gallery.length === 0
                          ? <div><EmptyMessage message='Gallery is empty.' /></div>
                          : <div>
                            {
                              product.gallery.map((image, i) =>
                                <a key={i} href={image} target={'_blank'} style={{ marginRight: 10, marginBottom: 10, display: 'inline-block' }}>
                                  <ImageComp
                                    src={image}
                                    defaultSrc={getImageSource()}
                                    size={50}
                                  />
                                </a>
                              )
                            }
                          </div>
                      }
                    </Grid> */}
                </Grid>


                {/* Button - Save */}
                <Grid item xs={12} className={classes.buttonsContainer}>
                  <IconButton
                    type={"button"}
                    aria-label={"Close"}
                    onClick={this.back}
                  >
                    <IconClose />
                  </IconButton>

                  <IconButton
                    type={"submit"}
                    aria-label={"Save"}
                    color={"primary"}
                    disabled={isLoadingSubmit || !permissions.canEdit}
                  >
                    <CheckIcon />
                  </IconButton>
                </Grid>
              </form>
            )}
            <Dialog
              onClose={this.handleClose}
              open={this.state.purchaseShow}
              aria-labelledby="simple-dialog-title"
              fullWidth={true}
              disabled={!permissions.canEdit}
            >
              <DialogTitle id="simple-dialog-title">
                Purchase Addition
              </DialogTitle>
              <DialogContent>
                <div>
                  <Grid container spacing={10} className={classes.buttonUpload}>
                    <Grid item xs={7}>
                      {/* Input - Unit */}
                      <TextField
                        name={"purchase"}
                        value={this.state.purchaseCount}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value >= 0) {
                            this.onTypePopup(e);
                          }
                        }}
                        label={"Added stock"}
                        placeholder={"Purchase Count (eg: 100)"}
                        required={true}
                        type="number"
                        margin={"dense"}
                        autoComplete={"off"}
                      />
                    </Grid>

                    <Grid item xs={4}>
                      {/* Input - Can Subscribe */}
                      <Button
                        variant="primary"
                        onClick={this.updatePurchaseCount}
                      >
                        Add Stock
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </DialogContent>
            </Dialog>
          </SectionPaper>
        </Grid>
      </div>
    );
  }
}

// Component Properties
CreateOrUpdate.propTypes = {
  auth: PropTypes.object.isRequired,
  categories: PropTypes.object.isRequired,
  details: PropTypes.func.isRequired,
  createOrUpdate: PropTypes.func.isRequired,
  listVendorsAll: PropTypes.func.isRequired,
  fetchUserDetail: PropTypes.func.isRequired,
  listCategories: PropTypes.func.isRequired,
  getUnitType: PropTypes.func.isRequired,
  messageShow: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

// Component State
function createOrEditState(state) {
  return {
    auth: state.auth,
    categories: state.categories,
  };
}

export default connect(createOrEditState, {
  details,
  createOrUpdate,
  productPurchase,
  listVendorsAll,
  fetchUserDetail,
  listCategories,
  upload,
  multipleUpload,
  messageShow,
  getUnitType,
  fetchSettingDetail
})(withStyles(styles)(CreateOrUpdate));
